import React from 'react';
import { StyleSheet, View, FlatList, Dimensions, LayoutAnimation, ViewToken, NativeSyntheticEvent, NativeScrollEvent  } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { FontAwesome } from '@expo/vector-icons';
import { Connection, ConnectionMkt, ConnectionOrd, } from '../~Utilities/Connection';
import {ReturnTypes, AppMain, FontInfo, EvtData } from '../~Utilities/Constants';
import Utilities from '../~Utilities/Utilities';
import SymbolInfo from './SymbolInfo';
import TextInputEx from '../C_Text/TextInputEx';
import {Data} from '../~Utilities/Data';
import ModalEx from '../C_Popups/ModalEx';

let oTxtSearch    : TextInputEx | null;
//const ITEM_HEIGHT = OB.WHITE_HEIGHT + 30; 

// function IsLoggedIn() : boolean
// {
// if (Connection.bSettingsLocal == true)
//   {
//   if (ConnectionMkt.oConn)
//     return(ConnectionMkt.oConn?.GetLoginStatus());
//   else
//     return(false);
//   }

// if (ConnectionOrd.oConn)
//   return(ConnectionOrd.oConn?.GetLoginStatus());
// else
//   return(false);

  // if (ConnectionMkt.oConn)
  //   return(ConnectionMkt.oConn?.GetLoginStatus());
  // else
  //   return(false);


// if (ConnectionOrd.bSettingsLocal == true)
//   {
//   if (ConnectionMkt.oConn)
//     return(ConnectionMkt.oConn?.GetLoginStatus());
//   else
//     return(false);
//   }

// if (ConnectionOrd.oConn)
//   return(ConnectionOrd.oConn?.GetLoginStatus());
// else
//   return(false);
// }

/*   ------------------------------------------------------------------------   */

export interface ISymbolList
{
  removeSymbol : (sToken: string)=>void;
  //setTxtSearch : (oInput: TextInputEx | null)=>void;
  bindEvent    : (onEvent    : (() => void), 
                  bSubscribe : boolean) => void
}

/*   ====================================================================   */

export interface ISymbolState
{
  visible : boolean;
  columns : number;
  data    : Data[];
}

/*   ====================================================================   */

export interface IViewParams
{
  viewableItems: Array<ViewToken>;
  changed: Array<ViewToken>;
}

/*   ====================================================================   */

export default class SymbolList extends React.Component<ISymbolList> //<{removeSymbol:any, setTxtSearch:any, bindEvent:any}>
 {
   public   iRefreshCount                 = 0;

   public   bIndexTo                      = false;
   public   iIndexTo                      = 0; //AppMain.IMAGINARY;
  //  public   sIndexToToken : string | null = null;
   private  oFlatList : FlatList | null   = null;
   private  oSymbols  : SymbolInfo[]      = new Array(0);
   private  iScale = 1;

   /*   ------------------------------------------------------------------   */

   Refresh(bRefreshChart : boolean)
   {
    if (__DEV__)    
      Utilities.Sendlog("refreshing flatlist...");

     this.iRefreshCount++;

     //this.bIndexTo = true;
     //this.iIndexTo = this.state.data.length;

     this.setState({data:Array.from(ConnectionMkt.oStore.values())});

     if (bRefreshChart)
      {
      for (let i = 0; i < this.oSymbols.length; i++)
      {
      //if (this.oSymbols[i].props.oData.obo_visible)
        {
        //if (this.oSymbols[i].curr_page == 0)
          {
          this.oSymbols[i].props.oData.update_chart_rr = true;
          //this.oSymbols[i].UpdateChart(); //props.oData.update_chart = true;
          }
        }
      }
    }

     //this.forceUpdate();
   }

  /*   -------------------------------------------------------------------   */

  NavigateTo(iIndex    : number,
             bAnimated : boolean = true)
  {
  if (this.oFlatList)
    {
    let iItem = Math.trunc(iIndex/this.state.columns); //Utilities.round(Math.floor((iIndex/this.state.columns)), 0);

    if (__DEV__)
      Utilities.Sendlog("navigating flatlist..." + iItem);

    if (bAnimated)
      setTimeout(() => this.oFlatList?.scrollToIndex({animated:true, index:iItem}), 100);
    else
      this.oFlatList?.scrollToIndex({animated:false, index:iItem});
    }
  }

 /*   -------------------------------------------------------------------   */

  UpdateSymbols(bUpdateChart : boolean)
  {
  if (__DEV__)    
    Utilities.Sendlog("add symbol flatlist...");

  //this.setAnimation();
  //this.iIndexTo = this.state.data.length;

  this.setState({data:Array.from(ConnectionMkt.oStore.values())});

  if (bUpdateChart)
    {
    for (let i = 0; i < this.oSymbols.length; i++)
    {
    //if (this.oSymbols[i].props.oData.obo_visible)
      {
      //if (this.oSymbols[i].curr_page == 0)
        {
        this.oSymbols[i].props.oData.update_chart_rr = true;
        //this.oSymbols[i].UpdateChart(); //props.oData.update_chart = true;
        }
      }
    }
    }
  }

 /*   -------------------------------------------------------------------   */

  UpdateSymbolsOnRefData(oData : Data)
  {
  if (__DEV__)    
    Utilities.Sendlog("add symbol flatlist...");

  //this.setAnimation();
  //this.iIndexTo = this.state.data.length;

  this.setState({data:Array.from(ConnectionMkt.oStore.values())});

  for (let i = 0; i < this.oSymbols.length; i++)
    {
      this.oSymbols[i].props.oData.update_chart_rr = true;
      this.oSymbols[i].UpdatePositionData(oData);
    }
  }

  /*   -------------------------------------------------------------------   */

  UpdatePositionsOnRefData(oData : Data)
  {
  for (let i = 0; i < this.oSymbols.length; i++)
    this.oSymbols[i].UpdatePositionData(oData);
  }

  /*   -------------------------------------------------------------------   */

  UpdateOBOnSub(oData : Data)
  {
  for (let i = 0; i < this.oSymbols.length; i++)
    this.oSymbols[i].onSubOB(oData);
  }

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.Refresh                  = this.Refresh.bind(this);
  this.UpdateSymbols            = this.UpdateSymbols.bind(this);
  this.UpdateSymbolsOnRefData   = this.UpdateSymbolsOnRefData.bind(this);
  this.UpdatePositionsOnRefData = this.UpdatePositionsOnRefData.bind(this);
  this.UpdateOBOnSub            = this.UpdateOBOnSub.bind(this);

  this.renderItem               = this.renderItem.bind(this);
  this.GetColumns               = this.GetColumns.bind(this);
  this.UpdateFont               = this.UpdateFont.bind(this);
  this.OnSubscribe              = this.OnSubscribe.bind(this);
           
  this.UpdateEvt                = this.UpdateEvt.bind(this);
  this.UpdateEvtAdv             = this.UpdateEvtAdv.bind(this);
  this.UpdateEvtAvbl            = this.UpdateEvtAvbl.bind(this);
  this.UpdateFont               = this.UpdateFont.bind(this);


  this.onViewableItemsChanged = this.onViewableItemsChanged.bind(this);

  this.state        = {visible:false,
                      columns:this.GetColumns(),
                      data:Array.from(ConnectionMkt.oStore.values())
                      };
  
  //Utilities.Sendlog("Flatlist ctr");
  //setAnimation();
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  }

  componentWillUnmount() 
  {
  }

  componentDidUpdate() 
  {
    if (__DEV__)
      Utilities.Sendlog("***************SYMBOL LIST**************");

    for (let i = 0; i < this.oSymbols.length; i++)
      {
      //if (this.oSymbols[i].props.oData.obo_visible)
        {
        if (this.oSymbols[i].curr_page != 1)
          {
          //Utilities.Sendlog(this.oSymbols[i].props.oData.token + " current page: " + this.oSymbols[i].curr_page);
          ConnectionMkt.UnSubscribeOB(this.oSymbols[i].props.oData);
          this.oSymbols[i].props.oData.visible_index = 0;
          }
        }
      }
  }

  /*   -------------------------------------------------------------------   */

  UpdateFont()
  {
  for (let i = 0; i < this.oSymbols.length; i++)
    {
    this.oSymbols[i].obRef?.UpdateFont();
    this.oSymbols[i].ordRef?.UpdateFont();
    this.oSymbols[i].evtRef?.UpdateFont();
    }
  }

  /*   -------------------------------------------------------------------   */

  UpdateEvt(oData : EvtData)
  {
  for (let i = 0; i < this.oSymbols.length; i++)
    {
    this.oSymbols[i].UpdateEvtData(oData);
    }
  }

  /*   -------------------------------------------------------------------   */

  UpdateEvtAvbl(oData : Data)
  {
  for (let i = 0; i < this.oSymbols.length; i++)
    {
    this.oSymbols[i].UpdateEvtAvbl(oData);
    }
  }

  /*   -------------------------------------------------------------------   */

  UpdateEvtAdv()
  {
  for (let i = 0; i < this.oSymbols.length; i++)
    {
    this.oSymbols[i].UpdateEvtAdv();
    }
  }

  /*   -------------------------------------------------------------------   */

  readonly setAnimation = () => {
    LayoutAnimation.configureNext({
      duration: 200,
      update: {
        type: LayoutAnimation.Types.easeIn,
        springDamping: 0.7,
      },
    });
    LayoutAnimation.configureNext({
      duration: 400,
      create: {
        type: LayoutAnimation.Types.easeIn,
        property: LayoutAnimation.Properties.scaleXY,
        springDamping: 0.7,
      },
    });
  };
  
  /*   ------------------------------------------------------------------------   */
  
  shouldComponentUpdate()
  {
  if (__DEV__)    
    Utilities.Sendlog("shouldupdate flatlist...");

  this.oSymbols.splice(0, this.oSymbols.length);

  if (Connection.IsLoggedIn() && this.iRefreshCount == 0)
    this.setAnimation();

  if (ConnectionMkt.oStore.size != this.state.data.length)
    {
    if (__DEV__)      
      Utilities.Sendlog("shouldupdate flatlist...YES");

    this.setState({data:Array.from(ConnectionMkt.oStore.values())});    
    return(true);
    }
  else

    return(true);
  }

  /*   -------------------------------------------------------------------   */

  state : ISymbolState = {visible:false,
                          columns:0,
                          data:Array(0),
                          };

  /*   ---------------------------------------------------------------------   */

  readonly renderItem = ({ item }) => 
    {
    return (
            <View key={item.token} style={[styles.sym_container, {backgroundColor:'transparent'}]}>
              {/* <Text style={{color:'black', fontSize:20}}>{item.x?.toString()}</Text> */}
            <SymbolInfo ref={node => { if (node) this.oSymbols.push(node)}}  
                        key={item.token} 
                        oData={item} Remove={this.props.removeSymbol} bindEvent={this.props.bindEvent}/>
            </View>
      );
    };

  /*   ---------------------------------------------------------------------   */

  readonly onLayout = () => 
  {

   // Utilities.Sendlog("***************layout changed...*************");

    let iNum = this.GetColumns();

    if (iNum != this.state.columns)
      {
      for (let i = 0; i < this.oSymbols.length; i++)
      {
      //if (this.oSymbols[i].props.oData.obo_visible)
        {
        //if (this.oSymbols[i].curr_page == 0)
          {
          this.oSymbols[i].props.oData.update_chart_rr = true;
          //this.oSymbols[i].UpdateChart(); //props.oData.update_chart = true;
          }
        }
      }

      ModalEx.oModalEx?.Hide();
      this.bIndexTo = true;
      this.setState({columns:iNum});
      }
  };

/*   ---------------------------------------------------------------------   */

  readonly footer = () => {
    return (
      <View removeClippedSubviews={false}>
      <TextInputEx
          //ref={node => { oTxtSearch = node; this.props.setTxtSearch(oTxtSearch); }}
          getstyle= {()=>{return(oTxtSearch?.state.error == ReturnTypes.ERR_INVALID? styles.input_invalid : styles.input)}}
          placeholder="enter such as aapl.q, es.cme"
          placeholderTextColor="grey"
          initValue={"init"}

          autoCorrect={false}
          spellCheck={false}
          autoCompleteType='off'
          
          //removeClippedSubviews={false}
    
          // onChangeText={text=>{}}
          //onBindTxtEvent={BindSearch}
          onSubmitEditing={()=>
                  {
                  //alert(oTxtSearch?.GetText1());
                  let iErr = ConnectionMkt.GetSymbolInfo(oTxtSearch?.GetText()); 
                  //alert("txt submit: " + iErr);
                  oTxtSearch?.UpdateError(iErr);
                  }}
      />

      <View style={{ flexDirection: 'row', alignSelf: 'center', backgroundColor:'transparent' }}>
    
      <TouchableOpacity
            style={[styles.button_plus, {}]}
            
            onPress={()=>
              {
              //alert(oTxtSearch?.GetText1());
              let iErr = ConnectionMkt.GetSymbolInfo(oTxtSearch?.GetText()); 
              //alert("button submit: " + iErr);
              oTxtSearch?.UpdateError(iErr);
              }}
          >
     
      <FontAwesome style={{ marginBottom: -3 }} name="plus" size={30} color="white" />
    
      {/* <Text>{new Date().toTimeString()}</Text> */}
    
      </TouchableOpacity>
      </View>
      </View>
      );
  }

  /*   -------------------------------------------------------------------   */

  GetColumns()
  {
    let {width, height} = Dimensions.get('window');

    let iNum = Math.round(width/( Utilities.WIDTH * this.iScale )) - 1;

    if (iNum < 1) iNum = 1;

      return(iNum);
  }

  /*   -------------------------------------------------------------------   */

  static readonly viewabilityConfig = 
  {
    waitForInteraction: false,
    minimumViewTime: 600,
    // At least one of the viewAreaCoveragePercentThreshold or itemVisiblePercentThreshold is required.
    viewAreaCoveragePercentThreshold: 5,
  }

  /*   -------------------------------------------------------------------   */

  static Find(oItems : ViewToken[], sToken)
  {
  for (let i = 0; i < oItems.length; i++)
    {
    if (oItems[i].item.token == sToken)
      return(oItems[i]);
    }

  //return(undefined);    
  }

  /*   -------------------------------------------------------------------   */

  OnSubscribe(sToken)
  {
  for (let i = 0; i < this.oSymbols.length; i++)
    {
    if (this.oSymbols[i].props.oData.token == sToken)
      {
      if (this.oSymbols[i].curr_page == 1)
        ConnectionMkt.SubscribeOB(this.oSymbols[i].props.oData);
      else
        ConnectionMkt.UnSubscribeOB(this.oSymbols[i].props.oData);

      return;
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  
  //onViewableItemsChanged = ({oViewableItems, changed}) => 
  //ViewableItemsChanged ({ viewableItems: Array<ViewToken>, changed: Array<ViewToken>})

  onViewableItemsChanged ({viewableItems, changed} : IViewParams) 
    {
    //Utilities.Sendlog("Visible items: " + viewableItems.length);

    //eco dis
    //if (ConnectionMkt.bEco == true)
    //  return;

    //Utilities.Sendlog("Visible items: step1");


    let bAssigned = false;

    for (let [sKey, oData] of ConnectionMkt.oStore.entries()) 
    {
    let z = SymbolList.Find(viewableItems, sKey);

    if (!z)
      {
      if (oData.sub_mkt == true)
        {
        if (__DEV__)          
          Utilities.Sendlog("Visible items: rem sub: " + oData.token);

        ConnectionMkt.RemoveSymbolSub(oData);
        }
      }
    else
      {
      if (z.index != null && bAssigned == false && this.bIndexTo == false)
          {
          this.iIndexTo = z.index;
          bAssigned     = true;

          if (__DEV__)
            Utilities.Sendlog("***********First Item assigned: " + oData.token);
          }

      //Utilities.Sendlog("Viewed item: " + key);
      //Utilities.Sendlog("Visible items: add sub: " + oData.token);

      // let z = FindSymbolInfo(this.o)

      //if (oData.sub_mkt == false)
        {
        if (__DEV__)          
          Utilities.Sendlog("Visible items: add sub: " + oData.token);

        ConnectionMkt.AddSymbolSub(oData);
        }

  // ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
  //                               Connection.MSG_SUBSCRIBE,
  //                               oData.token);

      }
    //console.log(key + " " + val);
    }

    this.bIndexTo = false;
    //console.log("Changed in this iteration", changed);
  //};
  }
  
  /*   -------------------------------------------------------------------   */

  // getItemLayout = (data, index) => {

  //   if (OB.WHITE_HEIGHT == 0)
  //     console.log("item layout error");

  //   return { length: OB.WHITE_HEIGHT + 30, 
  //            offset: (OB.WHITE_HEIGHT + 30) * index, 
  //            index };
  // }

  /*   -------------------------------------------------------------------   */

  static readonly getKey = (data : Data) => 
    {
    //console.log("item layout");
    return (data.token);
    }

  /*   -------------------------------------------------------------------   */

  render() 
   {
    if (__DEV__)    
      Utilities.Sendlog("Flatlist item count: " + this.state.data.length); 
    //ModalEx.oModalEx?.Hide();
    //setAnimation();
    //this.iRenderCount++;

    //Utilities.Sendlog("Flatlist render count: " + this.iRenderCount)

    // if (this.state.visible == false) 
    // return(null);
    // else  
    return(
      // <View style={IsLoggedIn() == false? {display: "none"} : {backgroundColor:'transparent', marginTop:8, display: "flex",/* backgroundColor:'#36454f'*/  }}>

      <FlatList ref={(node)=>{this.oFlatList = node}} style={Connection.IsLoggedIn() == false? {display: "none"} : {marginTop:6}} contentContainerStyle={{marginTop:-20, alignSelf:'center', backgroundColor:'transparent', alignContent:'center', alignItems:'center'}}
      onLayout={this.onLayout}
      //   ()=>{
      //   let iNum = this.GetColumns();

      //   if (iNum != this.state.columns)
      //     this.setState({columns:iNum});

      //     //console.log("layout");
      // }}
      //onScrollAnimationEnd={()=>{ this.oFlatList.scr }}

      // initialScrollIndex={500}

      //scrollEventThrottle={100}

      // onScroll =
      // {
      //   (event: NativeSyntheticEvent<NativeScrollEvent>)=>
      //     { 
      //       this.iScale = event.nativeEvent.zoomScale;

      //       Utilities.Sendlog("Z: " + event.nativeEvent.zoomScale);

      //       let iNum = this.GetColumns();

      //       Utilities.Sendlog("col: " + iNum );

      //       if (iNum != this.state.columns)
      //         {
      //         ModalEx.oModalEx?.Hide();
      //         //this.bIndexTo = true;
      //         this.setState({columns:iNum});
      //         }

      //       //Utilities.Sendlog("Z: " + event.nativeEvent.zoomScale) 
      //     }
      // }

      onContentSizeChange={(w: number, h: number) => {
        if (this.oFlatList                          && 
            //this.iIndexTo != AppMain.IMAGINARY      && 
            this.iIndexTo < this.state.data.length  &&
            this.bIndexTo == true
            ) 
          {
          
          if (this.iIndexTo == undefined)
            return;

          let iItem = Math.trunc(this.iIndexTo/this.state.columns);

          

          this.oFlatList.scrollToIndex({  animated:false, index: iItem });
          //this.iIndexTo = AppMain.IMAGINARY;
          //this.bIndexTo = false;
          }
      }}

      //minimumZoomScale={0.1}
      //maximumZoomScale={2}

      // maximumZoomScale={3}
      // minimumZoomScale={.5}
      
      onScrollToIndexFailed={()=>{if (__DEV__) 
                                    Utilities.Sendlog("scroll failed"); 
                                  }}
      data={this.state.data} //{Array.from(ConnectionMkt.oStore.values())}
      renderItem={this.renderItem}
      numColumns={this.state.columns}
      key={this.state.columns + "-" + this.iRefreshCount}
      //maxToRenderPerBatch={10}
      windowSize={31}
      keyExtractor={SymbolList.getKey}
      //ListFooterComponent={this.footer}
      viewabilityConfig={SymbolList.viewabilityConfig}
      onViewableItemsChanged={this.onViewableItemsChanged}
      //getItemLayout={this.getItemLayout}
      //removeClippedSubviews={true}
      />
      ); 

   }
}

/*   =====================================================================   */

const styles = StyleSheet.create({

    container_sort_cover: {
      backgroundColor: 'transparent',
      alignSelf:'center',
      width:200,
    },
  
    container_sort: {
      backgroundColor: 'transparent',
      alignSelf:'center',
    },
  
    tile_sort: {
      backgroundColor:'transparent',
      width: '100%',
      height: '100%',
    },

    sym_container:
    {
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: "center",//"space-between",
    backgroundColor: "transparent",
    padding: 0,
    margin: 0,
    },

    button_plus: 
    {
    width:100,
    height:100,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    backgroundColor: 'cornflowerblue',
    padding:10,
    margin:10,
    },

    // input_view:
    // {
    //   alignSelf:'center',
    //   width:350,
    //   height: 40,
    //   margin: 12,
    //   borderWidth: 1,
    //   //padding: 10,
    //   borderColor:'white',
    //   borderRadius: 20,
    //   backgroundColor:'white',
    // },

    // input: 
    // {
    // fontSize:15,
    // width:350,
    // height: 40,
    // marginLeft: 10,
    // backgroundColor:'white',
    // color:'black',

    // borderWidth: 1,
    // borderColor:'white',
    // borderRadius: 20,

    // },

    // input_invalid: 
    // {
    // fontSize:15,
    // width:350,
    // height: 40,
    // margin: 12,
    // marginLeft: 10,
    // backgroundColor:'lightpink',
    // color:'black',

    // borderWidth: 1,
    // borderColor:'white',
    // borderRadius: 20,
    // },

    input: 
    {
    //textAlign:'center',  
    alignSelf:'center',
    fontSize: FontInfo.iFontSize + 3,
    width:Utilities.WIDTH,
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
    borderColor:'white',
    borderRadius: 20,
    backgroundColor:'white',
    color:'black',
    },

    input_invalid: 
    {
    //textAlign:'center',        
    alignSelf:'center',
    fontSize: FontInfo.iFontSize + 3,
    width:Utilities.WIDTH,
    height: 40,
    margin: 12,
    color:'black',
    borderWidth: 1,
    borderColor:'white',
    padding: 10,
    borderRadius: 20,
    backgroundColor:'lightpink',
    //color:'black',
    },
});